import { UseFormReturn } from "react-hook-form";
import YubinBango from "yubinbango.js";
import { Options } from "../../public/shared/lib/types";
import { fullwidthTohalfWidth } from "./numberUtils";

const fillAddressByPostalCode = async ({
  prefectures,
  postalCode,
  form,
}: {
  prefectures: Options;
  postalCode: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
}) => {
  const transformed = fullwidthTohalfWidth(postalCode).replace(/[ー\-−―‐ｰ－]/g, "");
  if (transformed.length !== 7) return;

  try {
    const address = await YubinBango.getAddress(transformed);
    const prefectureId = prefectures.find(
      (prefecture) => prefecture.name === address.prefecture,
    )!.id;

    form.setValue("prefecture_id", prefectureId.toString());
    form.setValue("address1", `${address.locality}${address.street}`);
    if (address.extended) form.setValue("address2", address.extended);

    form.clearErrors("postal_code");
  } catch (e) {
    if (e instanceof Error && e.message.includes(`Can't find matched data.`)) {
      form.setError("postal_code", { message: "存在しない郵便番号です" });
    } else {
      throw e;
    }
  }
};

export default fillAddressByPostalCode;
